import { useEffect } from 'react';

function DropdownClickOutsideController({ usePortal, dropdownOpen, wrapperRef, portalRef, onClose }) {
  useEffect(() => {
    if (!usePortal || !dropdownOpen) return;
    const handleClick = (e) => {
      if (wrapperRef.current?.contains(e.target) || portalRef.current?.contains(e.target)) return;
      onClose();
    };
    document.body.addEventListener('click', handleClick);
    return () => document.body.removeEventListener('click', handleClick);
  }, [usePortal, dropdownOpen, wrapperRef, portalRef, onClose]);

  return null;
}

export default DropdownClickOutsideController;
